import { networkSol } from "../networks";
import { SolLogo } from "based-assets";
import { IChain, ChainSymbols, ChainIds } from "./types";
import { defineChain } from "viem";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";

export const chainSol: IChain = defineChain({
  id: ChainIds.sol,
  symbol: ChainSymbols.sol,
  name: "Solana",
  logo: SolLogo,
  network: networkSol,
  nativeCurrency: { name: "Solana", symbol: "SOL", decimals: 9 },
  rpcUrls: {
    default: {
      http: [
        clusterApiUrl(WalletAdapterNetwork.Mainnet),
        "https://late-indulgent-surf.solana-mainnet.quiknode.pro/06bfbf9317a2dac06f06abf1087a9ea64cd0da56/",
      ],
    },
  },
  blockExplorers: {
    default: {
      name: "Solscan",
      url: "https://explorer.solana.com",
      hash: "https://solscan.io/tx/{{addr}}",
      address: "https://solscan.io/account/{{addr}}",
    },
  },
});

export const chainSolDevnet: IChain = defineChain({
  id: ChainIds.solDevnet,
  symbol: ChainSymbols.solDevnet,
  name: "Solana Devnet",
  logo: SolLogo,
  network: networkSol,
  nativeCurrency: { name: "Solana", symbol: "SOL", decimals: 9 },
  rpcUrls: {
    default: {
      http: [
        clusterApiUrl(WalletAdapterNetwork.Devnet),
        "https://cosmological-quaint-friday.solana-devnet.quiknode.pro/c1f4aaab4ab76f04042e3902cdb03dc8a35b5c6d/",
        "https://rpc.walletconnect.org/v1",
      ],
    },
  },
  blockExplorers: {
    default: {
      name: "Solscan",
      url: "https://explorer.solana.com",
      hash: "https://solscan.io/tx/{{addr}}?cluster=devnet",
      address: "https://solscan.io/account/{{addr}}?cluster=devnet",
    },
    solana: {
      name: "Solana Explorer",
      url: "https://explorer.solana.com",
      hash: "https://solscan.io/tx/{{addr}}?cluster=devnet",
      address: "https://solscan.io/account/{{addr}}?cluster=devnet",
    },
  },
  testnet: true,
});
